<a-center-popup [title]="'Create Swimlane'" (close)="onClose()">
  <swimlane-edit-from [submit$]="submit$" [boardId]="boardId"></swimlane-edit-from>
  <div class="buttons-block">
    <button a-button [pending]="_formService.isPending$ | async" (click)="submit$.next()" class="btn_primary">Save</button>
    <button a-button class="btn_secondary" (click)="onClose()">Cancel</button>
  </div>
</a-center-popup>
